<template>
  <div id="app" style="-webkit-overflow-scrolling: touch;-webkit-overflow-scrolling: auto;">
    <navigation>
      <router-view></router-view>
    </navigation>
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {

    }
  },
  methods: {

  },
  created () {

    this.$store.state.u_partcode = localStorage.getItem("u_partcode");
    this.getSDKprd1();
    // this.IsLogin();
    sessionStorage.setItem('cphref', window.location.href)
  },
}

</script>

<style lang="scss">
.hide_sort_tab {
  // padding-top: 1.2rem;
  background-color: #fff;
  top: 0;
  width: 100%;
  z-index: 89;
}
.hide_search_box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 5px 5px;
  // position: fixed;
  width: 100%;
  z-index: 99;
  background-color: #fff;
}
.is_disabled {
  background-color: #999 !important;
}
.disabled_qbh {
  font-size: 12px;
  color: #fff;
  // padding: 0px 2px;
  background-color: #ff010a;
  width: 50px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 10px;
  span {
    line-height: 20px;
  }
}
.commParet {
  position: relative;
}
.comm_price_label_img {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 0px;
  left: 0px;
}
.comm_price_label_img img {
  width: 100%;
  height: 100%;
}

.comm_price_label_img_tb {
  width: 60px;
  height: 40px;
  position: absolute;
  top: 0px;
  right: 0px;
}
.comm_price_label_img_tb img {
  width: 100%;
  height: 100%;
}
.comm_price_label_img_tb_bt img {
  width: 100%;


}
.comm_label_tips_box {
  display: flex;
  margin: auto 10px;
  position: absolute;
  bottom: 3px;
}

.comm_label_tips_cell {
  text-align: center;
  display: inline-block;
  background: rgba(255, 255, 255, 1);
  padding: 2px 6px;
  border:1.4px solid rgba(228, 46, 60, 1);
  margin-right: 3px;
  color: rgba(228, 46, 60, 1);
  font-family: SourceHanSansCN-Regular;
  -webkit-text-size-adjust: none;
  font-size: 11px;
  border-radius: 3px;
}
//补贴添加
.comm_label_tips_box_bt {
  display: flex;
  position: absolute;
  bottom: 3px;
  right: 0px;
}

.comm_label_tips_cell_bt {
  text-align: center;
  display: inline-block;
  background: rgb(253, 64, 1);
  padding: 2px 6px;
  border:1.4px solid rgb(253, 64, 1);
  margin-right: 3px;
  color:#fff;
  font-family: SourceHanSansCN-Regular;
  -webkit-text-size-adjust: none;
  font-size: 11px;
  border-radius: 3px;
  border-bottom-left-radius:20px;
   border-top-left-radius:20px
}


.comm_label_tips_cell_bt_add {
  text-align: left;
  display: inline-block;

    background: url("./assets/images/bt_add_cart.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: #fff;
    width: 100%;
    height: 30px;
    line-height: 35px;
     font-size: 14px;
    font-weight: bold;

}

.comm_label_tips_cell_bt_xq {
  text-align: left;
    background: url("./assets/images/bt_xq.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: #fff;
    height: 50px;
    line-height: 53px;
    font-size: 14px;
    font-weight: bold;

}
.shopcartDialog-item-content {
  padding-bottom: 0px !important;
}
.comm_pop_label {
  margin: auto 20px;
  margin-bottom: 5px;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.van-toast--default {
}
.van-toast--default .van-toast__text {
  padding-top: 0;
}
.changeDefaultToast {
  width: 100px;
  height: 102px;
  min-height: 100px;
  padding: 0;
}
.toastFail {
  width: 100px;
}
.no_comm_label_tips_cell {
  display: none !important;
}
.search-box-logo {
  background: url("./assets/images/logo_.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 20px;
  height: 21px;
}
.search-box-logo2 {
  background: url("./assets/images/sBG2.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 80%;
  height: 27px;
  border-radius:15px;
}
.search-box-logo3 {
  background: url("./assets/images/sm.png");
  background-repeat: no-repeat;
  background-size: 100%;
  width: 21px;
  height: 21px;
}
.ModalBox-wrap-back {
  background: url(./assets/images/return.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 35px;
  width: 35px;
}
.stepper {
  background-color: #f0f2f5;
  padding: 27px;
  margin-bottom: 10px;
  &-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  &-bag {
    display: flex;
    align-items: center;
  }
  &-box,
  &-bag {
    justify-content: space-between;
    .price {
      color: #e42e3c;
      font-size: 15px;
      // margin-left: 10px;
      span {
        font-size: 12px;
        // margin-left: 9px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue